export class filterParameter {
    accountNumber: string;
    customerId: string;
    emailId: string;
    locationId: string;
    isStatusSaveOnDB: string;
    path: string;
}